import { useCustomTranslation } from '../../../localization/hooks/useCustomTranslation';
import { moduleId } from '../config';

export const useServiceRequestTranslation = (keyPrefix: string) =>
  useCustomTranslation({ moduleId, keyPrefix });
